var map = {
	"./components/faq-section/FaqSection.global": "674b",
	"./components/faq-section/FaqSection.global.vue": "674b",
	"./components/footer/Footer.global": "fa73",
	"./components/footer/Footer.global.vue": "fa73",
	"./components/info/Info.global": "b892",
	"./components/info/Info.global.vue": "b892",
	"./components/modals/ConsumptionInfoModal.global": "5f76",
	"./components/modals/ConsumptionInfoModal.global.vue": "5f76",
	"./components/widgets-container/WidgetsContainer.global": "0230",
	"./components/widgets-container/WidgetsContainer.global.vue": "0230",
	"./components/widgets/ConsumptionChart.global": "9ed6",
	"./components/widgets/ConsumptionChart.global.vue": "9ed6",
	"./components/widgets/CurrentMonthConsumption": "6592",
	"./components/widgets/CurrentMonthConsumption.vue": "6592",
	"./components/widgets/CurrentMonthConsumptionWidget.global": "2747",
	"./components/widgets/CurrentMonthConsumptionWidget.global.vue": "2747",
	"./components/widgets/CurrentYearConsumption": "e2d0",
	"./components/widgets/CurrentYearConsumption.vue": "e2d0",
	"./components/widgets/LastMonthComparisonConsumption": "dd63",
	"./components/widgets/LastMonthComparisonConsumption.vue": "dd63",
	"./components/widgets/LastMonthConsumptionWidget.global": "e682",
	"./components/widgets/LastMonthConsumptionWidget.global.vue": "e682",
	"./components/widgets/LastYearComparisonConsumption": "b0d6",
	"./components/widgets/LastYearComparisonConsumption.vue": "b0d6",
	"./components/widgets/LastYearConsumptionWidget.global": "bd16",
	"./components/widgets/LastYearConsumptionWidget.global.vue": "bd16",
	"./views/app/AppView": "e88b",
	"./views/app/AppView.vue": "e88b",
	"./views/widget/WidgetView": "21b4",
	"./views/widget/WidgetView.vue": "21b4"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | app-eed */ "app-eed").then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "73e6";
module.exports = webpackAsyncContext;